<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import WebDocumentViewer from "@/components/share/web-document-viewer";

/**
 * Form-element component
 */
export default {
  page: {
    title: "TemplateReport",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {  PageHeader, WebDocumentViewer },
  data() {
    return {
      title: "Template Report",
      items: [
        {
          text: "Reports",
          href: "/",
        },
        {
          text: "TemplateReport",
          active: true,
        },
      ]
    };
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Criteria</h4>
            <b-form>
              <b-form-group>
                <b-form-input
                  id="formrow-keyword-input"
                  type="text"
                  placeholder="Keyword"
                ></b-form-input>
              </b-form-group>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group>
                    <b-form-input
                      id="month"
                      value="2019-08"
                      type="month"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                </div>
              </div>
              <div>
                <b-button variant="primary" v-can="'submit'">Submit</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <WebDocumentViewer :reportUrl="'TemplateReport?logo_company=amazon'"></WebDocumentViewer>
    </div>
  </div>
</template>